<template>
  <datatable
    :url="ajaxUrl"
    :create-url="createUrl"
    :order-by="orderBy"
    :order-asc="orderAsc"
    refresh-on="reloadTable"
    search-placeholder="Search all ingredients..."
  >
    <template #headings>
      <sortableTh
        :current-order-by="orderBy"
        :order-asc="orderAsc"
        order-by="trade_name"
        @set-order-by="setOrder"
      >
        Trade Name
      </sortableTh>
      <sortableTh
        :current-order-by="orderBy"
        :order-asc="orderAsc"
        order-by="inci_name"
        @set-order-by="setOrder"
      >
        Name (INCI)
      </sortableTh>
      <th>CAS Number</th>
      <th>Function</th>
      <sortableTh
        :current-order-by="orderBy"
        :order-asc="orderAsc"
        order-by="created_at"
        @set-order-by="setOrder"
      >
        Created at
      </sortableTh>
      <th></th>
    </template>
    <template #rows="{ data }">
      <tr v-for="ingredient in data" :key="ingredient.id">
        <td>{{ ingredient.trade_name }}</td>
        <td>{{ ingredient.inci_name }}</td>
        <td>{{ ingredient.cas_number }}</td>
        <td>{{ ingredient.function }}</td>
        <td>{{ ingredient.created_at }}</td>
        <td v-html="ingredient.actions"></td>
      </tr>
    </template>
  </datatable>
</template>

<script setup>
import { ref } from "vue";
import datatable from "@/components/datatable.vue";
import sortableTh from "@/components/datatable/sortableTh.vue";

const props = defineProps({
  ajaxUrl: String,
  createUrl: String,
});

const orderBy = ref("created_at");
const orderAsc = ref(false);

const setOrder = function (input) {
  if (orderBy.value == input) {
    orderAsc.value = !orderAsc.value;
  } else {
    orderBy.value = input;
    orderAsc.value = true;
  }
};
</script>
